import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { AI_CHAT_STATUS_EVENT, toggleAiChat, type AiChatStatus } from "@/components/specific/ai/chatConstants";

export const AskVectaButton = () => {
  const [replying, setReplying] = useState(false);

  useEffect(() => {
    const handleStatus = (event: Event) => setReplying((event as CustomEvent<AiChatStatus>).detail.replying);
    window.addEventListener(AI_CHAT_STATUS_EVENT, handleStatus);
    return () => window.removeEventListener(AI_CHAT_STATUS_EVENT, handleStatus);
  }, []);

  return (
    <button
      type="button"
      onClick={toggleAiChat}
      className="relative flex items-center gap-1.5 px-3 h-8 text-sm text-white bg-(--layout-brand) hover:bg-(--layout-brand-hover) border border-white/40 hover:border-white rounded-[6px] transition-colors focus:outline-none"
    >
      <Sparkles className="size-4 text-amber-400" fill="currentColor" aria-hidden="true" />
      <span className="hidden sm:inline">Ask Vecta</span>
      {replying ? (
        <>
          <span
            aria-hidden="true"
            className="absolute -top-1 -right-1 size-2.5 animate-pulse rounded-full bg-amber-400 ring-2 ring-(--layout-brand)"
          />
          <span className="sr-only">Vecta is replying</span>
        </>
      ) : null}
    </button>
  );
};
